class KeyFeaturesExpander extends HTMLElement {
  #panels = [];

  connectedCallback() {
    this.#panels = Array.from(this.querySelectorAll('[data-key-features-panel]'));

    if (this.#panels.length === 0) return;

    this.#panels.forEach((panel) => {
      panel.addEventListener('mouseenter', () => this.#setActive(panel));
      panel.addEventListener('focusin', () => this.#setActive(panel));
      panel.addEventListener('click', () => this.#setActive(panel));
    });

    this.addEventListener('mouseleave', () => this.#clearActive());

    this.addEventListener('focusout', (event) => {
      const relatedTarget = event.relatedTarget;

      if (!(relatedTarget instanceof Node) || !this.contains(relatedTarget)) {
        this.#clearActive();
      }
    });
  }

  #setActive(panel) {
    this.#panels.forEach((item) => {
      const isActive = item === panel;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });
  }

  #clearActive() {
    this.#panels.forEach((item) => {
      item.classList.remove('is-active');
      item.setAttribute('aria-expanded', 'false');
    });
  }
}

if (!customElements.get('key-features-expander')) {
  customElements.define('key-features-expander', KeyFeaturesExpander);
}
